import RandomTestCard from "./RandomTestCard"
import OrderResultRecord from "../../api/OrderResults/OrderResultModel/OrderResultRecord"

interface ReasonForTestCellProps {
  row: OrderResultRecord
  useIcon?: boolean
}

function ReasonForTestCell(props: ReasonForTestCellProps) {
  const { row, useIcon } = props

  if (row.IsRandom) {
    return <RandomTestCard description={row.Reason} useIcon={useIcon} />
  }
  return <div className="d-flex align-items-center">{row.Reason}</div>
}

ReasonForTestCell.defaultProps = {
  useIcon: false,
}
export default ReasonForTestCell
